<template>
  <div id="contenedor-contratista-main-expediente">
    <v-card flat>
      <v-card-text>
        <v-list subheader two-line>
          <template
            v-for="expediente in getExpedientePorOrdenDocumento">
            <template>
              <v-list-item
                :key="expediente.id">
                <v-list-item-avatar class="grey lighten-4">
                  <v-icon color="primary">
                    mdi-folder-file
                  </v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>
                    <span class="font-weight-medium">
                      {{ expediente.documento.descripcion }}
                    </span>
                  </v-list-item-title>
                  <v-list-item-subtitle
                    v-if="expediente.referencia">
                    <span class="font-weight-bold">
                      Referencia:
                    </span>
                    <span>
                      {{ expediente.referencia }}
                    </span>
                  </v-list-item-subtitle>
                  <v-list-item-subtitle
                  v-if="expediente.publicKey">
                  <v-row align="center">
                    <v-icon small class="mr-1">
                      mdi-calendar-month
                    </v-icon>
                    <span>
                      {{ $moment(expediente.updatedAt).format('DD/MM/YYYY') }}
                    </span>
                  </v-row>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <div
                  v-if="expediente.publicKey">
                  <v-btn
                  class="text-capitalize mr-1"
                  rounded
                  depressed
                  @click="verDocumento(expediente)">
                    <v-icon left color="primary">mdi-eye</v-icon>
                    Ver
                  </v-btn>
                  <v-btn
                    depressed
                    fab
                    small
                    :loading="expediente.descargando"
                    @click="descargarDocumento(expediente.id)">
                    <v-icon color="blue">
                      mdi-cloud-download
                    </v-icon>
                  </v-btn>
                </div>
              </v-list-item>
              <v-divider :key="`diviver-${expediente.id}`"></v-divider>
            </template>
          </template>
        </v-list>
      </v-card-text>
    </v-card>
      <v-dialog
        v-if="esteDocumentoExpediente"
        v-model="mostrarVerDocumentoExpediente"
        width="1200"
        scrollable>
        <v-card>
          <v-card-title class="secondary--text">
            {{esteDocumentoExpediente.documento.descripcion}}
            <v-spacer></v-spacer>
            <v-btn icon @click="cerrarVentana">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <ver-documento-pdf
            :documentoPdfVer="esteDocumentoExpediente"
            soloPdf
            v-on:cerrar="cerrarVentana"
          />
          </v-card-text>
          <v-divider class="bkground" />
          <v-card-actions>
            <v-spacer></v-spacer>
            <custom-button
              @click="cerrarVentana"
              tipo="formCancelar"
              label="Cerrar"
              class="mr-3">
            </custom-button>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </div>
</template>

<script>
import fileDownload from 'js-file-download';
import EXPEDIENTE_SUPERVISION_EXTERNA_POR_CONTRATO from '@/graphql/querys/administracion/expediente/expedienteSupervisionExternaPorContrato.gql';
import verDocumentoPdf from '@/components/VistaDocumentoPdf.vue';
import CustomButton from '@/components/buttons/Button.vue';

const BASE_URL = process.env.NODE_ENV !== 'production'
  ? 'http://localhost:3001'
  : 'https://sideop-file-server.hermosillo.gob.mx';

export default {
  name: 'ContratistaMainExpediente',
  data() {
    return {
      esteDocumentoExpediente: null,
      mostrarVerDocumentoExpediente: false,
    };
  },
  components: {
    verDocumentoPdf,
    CustomButton,
  },
  apollo: {
    expedienteSupervisionExternaPorContrato: {
      query: EXPEDIENTE_SUPERVISION_EXTERNA_POR_CONTRATO,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
      update: (data) => data.expedienteSupervisionExternaPorContrato.map((expediente) => ({
        ...expediente,
        descargando: false,
      })),
    },
  },
  methods: {
    verDocumento(expediente) {
      this.esteDocumentoExpediente = expediente;
      this.mostrarVerDocumentoExpediente = true;
    },
    cerrarVentana() {
      this.mostrarVerDocumentoExpediente = false;
      this.esteDocumentoExpediente = null;
    },
    async descargarDocumento(expedienteId) {
      const expedienteDescargar = this.expedienteSupervisionExternaPorContrato
        .find((expediente) => expediente.id === expedienteId);
      if (!expedienteDescargar) return;
      expedienteDescargar.descargando = true;
      await this.axios.get(
        `${BASE_URL}/${expedienteDescargar.publicKey}`,
        {
          responseType: 'blob',
        },
      )
        .then((res) => {
          fileDownload(res.data, `${expedienteDescargar.contrato.numero}-${expedienteDescargar.documento.descripcion}.pdf`);
        })
        .catch((err) => {
          this.mixMensajeError(err.data.message);
        });
      expedienteDescargar.descargando = false;
    },
  },
  computed: {
    getExpedientePorOrdenDocumento() {
      if (!this.expedienteSupervisionExternaPorContrato) return [];

      return this.expedienteSupervisionExternaPorContrato
        .slice()
        .sort((a, b) => a.documento.orden - b.documento.orden);
    },
  },
};
</script>

<style lang="scss">

</style>
